export const BIGQUERY_CLUSTER_REGION_MAPPING: { [key: string]: string } = {
  'asia': 'asia-southeast1',
  'in': 'asia-south1',
  'eu': 'EU',
  'us': 'US',
  'us2': 'US',
  'au': 'australia-southeast1',
  'classplus': 'asia-south1'
};
